import { createEventFactory } from '@cp/shared/tracking';
import { TariffViewModel } from '@common/model/billing/tariff/view';
import { getTariffTermLabel } from '@cp/entities/tariff';

type MinimalTariffInfo = Pick<TariffViewModel, 'period'>;
const injectTariff = (tariff?: MinimalTariffInfo | null): Record<string, string> => (tariff ? { 'Тариф': getTariffTermLabel(tariff) } : {});

export const BillingEvents = {
  TariffSelect: createEventFactory<Record<string, string>, MinimalTariffInfo | undefined>(
    {
      subject: 'billing',
      object: 'tariff',
      action: 'select',
      goalId: 'nazhatie_na_variant_tarifa_v_popape',
      goalName: 'Нажатие на вариант тарифа в попапе',
    },
    injectTariff,
  ),
  CardBindingModalOpen: createEventFactory({
    subject: 'billing',
    object: 'cardModal',
    action: 'open',
    result: 'success',
    nonInteraction: true,
    goalId: 'poyavlenie_popapa_s_privyazkoj_karty',
    goalName: 'Появление попапа с привязкой карты',
  }),
  CardBindingSend: createEventFactory({
    subject: 'billing',
    object: 'card',
    action: 'submit',
    goalId: 'nazhatie_na_knopku_privyazat_kartu',
    goalName: 'Нажатие на кнопку "Привязать карту"',
  }),
  CheckoutModalOpen: createEventFactory({ subject: 'billing', object: 'checkout', action: 'open' }),
  CheckoutModalSend: createEventFactory<Record<string, string>, MinimalTariffInfo | undefined>(
    { subject: 'billing', object: 'checkout', action: 'send' },
    injectTariff,
  ),
  PaymentSuccess: createEventFactory<Record<string, string>, MinimalTariffInfo | undefined | null>(
    {
      subject: 'billing',
      action: 'payment',
      result: 'success',
      goalId: 'uspeshnaya_oplata',
      goalName: 'Успешная оплата',
    },
    injectTariff,
  ),
  SubscriptionCancel: createEventFactory({
    subject: 'billing',
    object: 'subscription',
    action: 'cancel',
    goalId: 'nazhatie_na_knopku_otmenit_podpisku_',
    goalName: 'Нажатие на кнопку "Отменить подписку" ',
  }),
} as const;
